/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as Mustache from "mustache";
import * as moment from "moment-timezone";
import {UiInstantDateField} from "./UiInstantDateField";
import {TeamAppsUiContext} from "../../TeamAppsUiContext";
import {TeamAppsUiComponentRegistry} from "../../TeamAppsUiComponentRegistry";
import {AbstractUiTimeField} from "./AbstractUiTimeField";
import {AbstractUiDateTimeField} from "./AbstractUiDateTimeField";
import {UiLocalDateTimeFieldConfig, UiLocalDateTimeFieldSubCommandHandler, UiLocalDateTimeFieldSubEventSource} from "../../../generated/UiLocalDateTimeFieldConfig";
import {arraysEqual} from "../../Common";
import Moment = moment.Moment;

type LocalDateTime = [number, number, number, number, number, number, number];

export class UiLocalDateTimeField extends AbstractUiDateTimeField<UiLocalDateTimeFieldConfig, LocalDateTime> implements UiLocalDateTimeFieldSubEventSource, UiLocalDateTimeFieldSubCommandHandler {

	protected initialize(config: UiLocalDateTimeFieldConfig, targetElement: Element, context: TeamAppsUiContext) {
		super.initialize(config, targetElement, context);
		this.getMainDomElement().addClass("UiDateTimeField");
	}

	isValidData(v: LocalDateTime): boolean {
		return v == null || (Array.isArray(v) && typeof v[0] === "number" && typeof v[1] === "number" && typeof v[2] === "number" && typeof v[3] === "number" && typeof v[4] === "number");
	}

	protected displayCommittedValue(): void {
		let uiValue = this.getCommittedValue();
		if (uiValue) {
			let newMoment: Moment = moment([uiValue[0], uiValue[1] - 1, uiValue[2]]);
			this.trivialDateTimeField.setValue(newMoment as any);
		} else {
			this.trivialDateTimeField.setValue(null);
		}
	}

	public getTransientValue(): LocalDateTime {
		let value = this.trivialDateTimeField.getValue();
		if (value) {
			return [value.year, value.month - 1, value.day, value.hour, value.minute, 0, 0];
		} else {
			return null;
		}
	}

	public static getReadOnlyHtml(config: UiLocalDateTimeFieldConfig, value: LocalDateTime, context: TeamAppsUiContext, drawBorder: boolean): string {
		if (value != null) {
			console.log(value[0], value[1], value[2]);
			return `<div class="static-readonly-UiDateTimeField  ${drawBorder ? "bordered" : ""}">`
				+ Mustache.render(UiInstantDateField.comboBoxTemplate, UiInstantDateField.createDateComboBoxEntryFromLocalValues(value[0], value[1], value[2], config.dateFormat || context.config.dateFormat))
				+ Mustache.render(AbstractUiTimeField.comboBoxTemplate, AbstractUiTimeField.createTimeComboBoxEntry(value[3], value[4], config.timeFormat || context.config.timeFormat))
				+ '</div>';
		} else {
			return "";
		}
	}

	getDefaultValue(): LocalDateTime {
		return null;
	}

	public valuesChanged(v1: LocalDateTime, v2: LocalDateTime): boolean {
		console.log();
		console.log();
		console.log();
		console.log();
		console.log();
		console.log();
		console.log();
		console.log();
		return !arraysEqual(v1, v2);
	}

}

TeamAppsUiComponentRegistry.registerFieldClass("UiLocalDateTimeField", UiLocalDateTimeField);